<h2 mat-dialog-title>Upload CSV File</h2>
<div class="import-dialog">
	<div mat-dialog-content class="mat-dialog-content">
		<div class="file-chooser">
			<div class="file-name">
				<mat-form-field>
					<input matInput disabled="true" [value]="fileName">
				</mat-form-field>
				<button class="cancel-file" mat-icon-button *ngIf="true || selectedFile" (click)="resetInputFile(fileInput)"
					[disabled]="!selectedFile">
					<mat-icon>close</mat-icon>
				</button>
			</div>
			<div>
				<button class="load-csv-button" mat-flat-button (click)="fileInput.click()">
					<mat-icon>attach_file</mat-icon>
					Choose a file
				</button>
				<input hidden type="file" (click)="resetInputFile(fileInput)" #fileInput
					(change)="onFileChange($event)" accept=".csv,text/csv" />
			</div>
		</div>

		<div class="actions-button-container" mat-dialog-actions>
			<button [disabled]="!formData" class="action" mat-button mat-raised-button (click)="upload()">Upload</button>
			<button mat-button mat-raised-button cdkFocusInitial (click)="cancel()">Cancel</button>
		</div>
	</div>
</div>
